/* HEADSTRONG "ONE JOB" HOMEPAGE (Mockup 3) — 2026-09-11
   Hero day-panels and the stack builder.
   Loaded (deferred) by every hs-bf3-* section; the guard makes repeat loads no-ops.
   Re-initialises on shopify:section:load so the theme editor stays live.

   UPDATE 2026-09-12a: an unselected slot renders with its formula colour (a
   tint) rather than a neutral grey box, so the resting state reads as three
   jobs waiting to be filled instead of looking broken.

   UPDATE 2026-09-12b: every line of builder copy now comes from the section
   settings via cfg.copy, so wording is editable in Customize. Nothing here
   should hard-code shopper-facing words.

   UPDATE 2026-09-16: the lineup orbit moved out of this file. It is now drawn
   and animated by hs-orbit.js, which is shared with the Lab page lineup so
   both orbits behave identically. Do not re-add an initLineup here — two
   drawings of the same SVG cancel the animation. */
(function () {
  if (window.__hsbf3) return;
  window.__hsbf3 = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cfg(el) {
    var n = el.querySelector('[data-hsbf3-cfg]');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.__hsbf3_money);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function listNames(a) {
    return a.length === 1 ? a[0]
      : a.length === 2 ? a[0] + ' and ' + a[1]
      : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }

  /* ---------- Hero: three day panels ---------- */
  function initHero(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var jobs = [].slice.call(el.querySelectorAll('[data-hsbf3-job]'));
    if (!jobs.length) return;
    function setOn(i) {
      jobs.forEach(function (j, k) {
        j.classList.toggle('is-on', k === i);
        var b = j.querySelector('.hsbf3-job__top');
        if (b) b.setAttribute('aria-expanded', k === i ? 'true' : 'false');
      });
    }
    jobs.forEach(function (j, i) {
      var top = j.querySelector('.hsbf3-job__top');
      if (window.matchMedia('(hover:hover)').matches) {
        j.addEventListener('mouseenter', function () { setOn(i); });
      }
      if (top) top.addEventListener('click', function () { setOn(i); });
      j.addEventListener('focusin', function () { setOn(i); });
    });
  }

  /* ---------- Stack builder ---------- */
  function initBuilder(el) {
    if (el.getAttribute('data-ready')) return;
    var c = cfg(el);
    if (!c) return;
    el.setAttribute('data-ready', '1');

    /* All shopper-facing wording, editable in Customize. */
    var t = c.copy || {};
    var T = {
      empty_h: t.empty_h || 'Pick at least one job.',
      empty_p: t.empty_p || 'Your stack fills in as you choose.',
      prefix: t.prefix || 'Your stack:',
      one: t.one || 'One job covered.',
      two: t.two || 'Two jobs covered.',
      upsell: t.upsell || 'Add the third and it becomes the Daily Brain Stack.',
      full_h: t.full_h || 'That\u2019s the Daily Brain Stack.',
      full_p: t.full_p || 'All three jobs, one order.',
      full_sub: t.full_sub || 'Delivered on your schedule at {n}% off.',
      add: t.add || 'Add to cart',
      add_one: t.add_one || 'Add {names} to cart',
      add_stack: t.add_stack || 'Add the stack to cart',
      save: t.save || 'Save {n}% on every delivery'
    };
    function fill(s, vars) {
      return String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    }

    var picks = [].slice.call(el.querySelectorAll('[data-hsbf3-pick]'));
    var slots = el.querySelector('[data-hsbf3-slots]');
    var h3 = el.querySelector('[data-hsbf3-sum-h]');
    var p = el.querySelector('[data-hsbf3-sum-p]');
    var priceBox = el.querySelector('[data-hsbf3-price]');
    var buy = el.querySelector('[data-hsbf3-buy]');
    var warn = el.querySelector('[data-hsbf3-warn]');
    var sub = el.querySelector('[data-hsbf3-sub]');
    var subRow = el.querySelector('[data-hsbf3-subrow]');
    var order = ['bump', 'focus', 'sleep'];

    function selected() {
      return picks.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });
    }
    function canSubscribe(on) {
      if (on.length === 3 && c.stack && c.stack.selling_plan) return true;
      return on.length > 0 && on.every(function (k) { return c.formulas[k] && c.formulas[k].selling_plan; });
    }

    function update() {
      var on = selected();

      /* Slots: every slot carries its formula colour. Unselected slots show a
         tint of it, so the resting state reads as three jobs waiting rather
         than three broken boxes. */
      if (slots) {
        slots.innerHTML = order.map(function (k) {
          var f = c.formulas[k];
          if (!f) return '';
          var isOn = on.indexOf(k) > -1;
          if (!isOn) {
            return '<div class="hsbf3-slot" style="--c:' + f.color + '">' +
              '<span class="empty" aria-hidden="true"></span></div>';
          }
          return '<div class="hsbf3-slot is-fill" style="--c:' + f.color + '">' +
            (f.img ? '<img src="' + f.img + '" alt="Headstrong ' + f.name + '" loading="lazy">' : '') + '</div>';
        }).join('');
      }

      var names = on.map(function (k) { return c.formulas[k].name; });
      var isStack = on.length === 3 && c.stack && c.stack.id;
      var subOn = sub && sub.checked && canSubscribe(on);

      if (subRow) subRow.hidden = !canSubscribe(on);

      var total = 0, compare = 0;
      if (isStack) {
        total = c.stack.price;
        compare = c.stack.compare || 0;
      } else {
        on.forEach(function (k) {
          total += c.formulas[k].price;
          compare += c.formulas[k].compare || c.formulas[k].price;
        });
      }
      var shown = total;
      if (subOn && c.sub_percent) shown = Math.round(total * (100 - c.sub_percent) / 100);

      if (on.length === 0) {
        if (h3) h3.textContent = T.empty_h;
        if (p) p.textContent = T.empty_p;
        if (priceBox) priceBox.innerHTML = '';
        if (buy) { buy.textContent = T.add; buy.setAttribute('aria-disabled', 'true'); }
      } else {
        if (isStack) {
          if (h3) h3.textContent = T.full_h;
          if (p) p.textContent = T.full_p + (subOn ? ' ' + fill(T.full_sub, { n: c.sub_percent }) : '');
          if (buy) buy.textContent = T.add_stack;
        } else {
          if (h3) h3.textContent = T.prefix + ' ' + listNames(names) + '.';
          if (p) p.textContent = (on.length === 1 ? T.one : T.two) + ' ' + T.upsell;
          if (buy) buy.textContent = fill(T.add_one, { names: listNames(names) });
        }
        if (buy) buy.removeAttribute('aria-disabled');
        if (priceBox) {
          var html = '<b>' + money(shown) + '</b>';
          if (compare > shown) html += '<s>' + money(compare) + '</s>';
          if (subOn && c.sub_percent) html += '<em>' + fill(T.save, { n: c.sub_percent }) + '</em>';
          priceBox.innerHTML = html;
        }
      }

      if (warn) warn.hidden = !(on.indexOf('bump') > -1 && on.indexOf('focus') > -1);
    }

    picks.forEach(function (x) { x.addEventListener('change', update); });
    if (sub) sub.addEventListener('change', update);

    if (buy) {
      buy.addEventListener('click', function (e) {
        e.preventDefault();
        var on = selected();
        if (!on.length) return;
        var subOn = sub && sub.checked && canSubscribe(on);
        var items = [];
        if (on.length === 3 && c.stack && c.stack.id) {
          items.push(buildItem(c.stack, subOn));
        } else {
          on.forEach(function (k) { items.push(buildItem(c.formulas[k], subOn)); });
        }
        buy.setAttribute('aria-disabled', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          buy.removeAttribute('aria-disabled');
          window.location.href = '/cart';
        });
      });
    }

    function buildItem(o, subOn) {
      var item = { id: o.id, quantity: 1 };
      if (subOn && o.selling_plan) item.selling_plan = o.selling_plan;
      return item;
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-hsbf3-hero]').forEach(initHero);
    document.querySelectorAll('[data-hsbf3-builder]').forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
